// This file is auto-generated by @hey-api/openapi-ts

import { client } from './client.gen.js';
import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client/index.js';
import type { AllNounQueryData, AllNounQueryErrors, AllNounQueryResponses, CompanyActionBulkSaveData, CompanyActionBulkSaveErrors, CompanyActionBulkSaveResponses, CompanyActionSaveData, CompanyActionSaveErrors, CompanyActionSaveResponses, CompanyGetChangeLogData, CompanyGetChangeLogErrors, CompanyGetChangeLogResponses, CompanyGetData, CompanyGetErrors, CompanyGetResponses, CompanyInsertData, CompanyInsertErrors, CompanyInsertResponses, CompanyQueryData, CompanyQueryErrors, CompanyQueryResponses, CompanySaveData, CompanySaveErrors, CompanySaveResponses, CompSetActionDownloadData, CompSetActionDownloadErrors, CompSetActionDownloadResponses, CompSetActionRateQueryData, CompSetActionRateQueryErrors, CompSetActionRateQueryResponses, CompSetDeleteData, CompSetDeleteErrors, CompSetDeleteResponses, CompSetGetData, CompSetGetErrors, CompSetGetHistoryData, CompSetGetHistoryErrors, CompSetGetHistoryResponses, CompSetGetResponses, CompSetPatchData, CompSetPatchErrors, CompSetPatchResponses, CompSetPutData, CompSetPutErrors, CompSetPutResponses, CompSetQueryData, CompSetQueryErrors, CompSetQueryResponses, ContentDownloadData, ContentDownloadErrors, ContentDownloadResponses, HotelActionBulkSaveData, HotelActionBulkSaveErrors, HotelActionBulkSaveResponses, HotelActionExcelRateChartData, HotelActionExcelRateChartErrors, HotelActionExcelRateChartResponses, HotelActionGsheetsRateChartData, HotelActionGsheetsRateChartErrors, HotelActionGsheetsRateChartResponses, HotelActionSaveData, HotelActionSaveErrors, HotelActionSaveResponses, HotelActionStatusesData, HotelActionStatusesErrors, HotelActionStatusesResponses, HotelGetChangeLogData, HotelGetChangeLogErrors, HotelGetChangeLogResponses, HotelGetData, HotelGetErrors, HotelGetResponses, HotelInsertData, HotelInsertErrors, HotelInsertResponses, HotelQueryData, HotelQueryErrors, HotelQueryResponses, HotelSaveData, HotelSaveErrors, HotelSaveResponses, LocationActionBulkSaveData, LocationActionBulkSaveErrors, LocationActionBulkSaveResponses, LocationActionSaveData, LocationActionSaveErrors, LocationActionSaveResponses, LocationGetChangeLogData, LocationGetChangeLogErrors, LocationGetChangeLogResponses, LocationGetData, LocationGetErrors, LocationGetResponses, LocationInsertData, LocationInsertErrors, LocationInsertResponses, LocationQueryData, LocationQueryErrors, LocationQueryResponses, LocationSaveData, LocationSaveErrors, LocationSaveResponses, OrganizationActionAllowedScopesData, OrganizationActionAllowedScopesErrors, OrganizationActionAllowedScopesResponses, OrganizationActionGsheetsFolderData, OrganizationActionGsheetsFolderErrors, OrganizationActionGsheetsFolderResponses, OrganizationActionUploadLogoData, OrganizationActionUploadLogoErrors, OrganizationActionUploadLogoResponses, OrganizationGetData, OrganizationGetErrors, OrganizationGetResponses, OrganizationSaveData, OrganizationSaveErrors, OrganizationSaveResponses, OrganizationUserGetData, OrganizationUserGetErrors, OrganizationUserGetResponses, OrganizationUserPatchData, OrganizationUserPatchErrors, OrganizationUserPatchResponses, OrganizationUserPutData, OrganizationUserPutErrors, OrganizationUserPutResponses, OrganizationUserQueryData, OrganizationUserQueryErrors, OrganizationUserQueryResponses, RateHistoryQueryRatesData, RateHistoryQueryRatesErrors, RateHistoryQueryRatesResponses, RateLatestQueryLatestData, RateLatestQueryLatestErrors, RateLatestQueryLatestResponses, RateStayQueryData, RateStayQueryErrors, RateStayQueryResponses, UserActionLeaveOrganizationData, UserActionLeaveOrganizationErrors, UserActionLeaveOrganizationResponses, UserGetCurrentUserData, UserGetCurrentUserErrors, UserGetCurrentUserResponses, UserGetOrganizationsData, UserGetOrganizationsErrors, UserGetOrganizationsResponses, UserInvitationDeleteData, UserInvitationDeleteErrors, UserInvitationDeleteResponses, UserInvitationInsertData, UserInvitationInsertErrors, UserInvitationInsertResponses, UserInvitationQueryData, UserInvitationQueryErrors, UserInvitationQueryResponses, UserSaveCurrentUserData, UserSaveCurrentUserErrors, UserSaveCurrentUserResponses } from './types.gen.js';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Query all-noun rows by name text search
 */
export const allNounQuery = <ThrowOnError extends boolean = false>(options?: Options<AllNounQueryData, ThrowOnError>): RequestResult<AllNounQueryResponses, AllNounQueryErrors, ThrowOnError> => (options?.client ?? client).get<AllNounQueryResponses, AllNounQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/all_nouns',
    ...options
});

/**
 * Query multiple relationships.
 */
export const compSetQuery = <ThrowOnError extends boolean = false>(options?: Options<CompSetQueryData, ThrowOnError>): RequestResult<CompSetQueryResponses, CompSetQueryErrors, ThrowOnError> => (options?.client ?? client).get<CompSetQueryResponses, CompSetQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comp_sets',
    ...options
});

/**
 * Download the stored rates file for the hotel competitive set.
 */
export const compSetActionDownload = <ThrowOnError extends boolean = false>(options: Options<CompSetActionDownloadData, ThrowOnError>): RequestResult<CompSetActionDownloadResponses, CompSetActionDownloadErrors, ThrowOnError> => (options.client ?? client).get<CompSetActionDownloadResponses, CompSetActionDownloadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comp_sets/{hotelId}/actions/download',
    ...options
});

/**
 * Get the latest rates for the hotel competitive set
 */
export const compSetActionRateQuery = <ThrowOnError extends boolean = false>(options: Options<CompSetActionRateQueryData, ThrowOnError>): RequestResult<CompSetActionRateQueryResponses, CompSetActionRateQueryErrors, ThrowOnError> => (options.client ?? client).get<CompSetActionRateQueryResponses, CompSetActionRateQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comp_sets/{hotelId}/actions/rate_query',
    ...options
});

/**
 * return the history for the hotel competitive set
 */
export const compSetGetHistory = <ThrowOnError extends boolean = false>(options: Options<CompSetGetHistoryData, ThrowOnError>): RequestResult<CompSetGetHistoryResponses, CompSetGetHistoryErrors, ThrowOnError> => (options.client ?? client).get<CompSetGetHistoryResponses, CompSetGetHistoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comp_sets/{hotelId}/history',
    ...options
});

/**
 * Delete a relationship. Return whether a delete occurred.
 */
export const compSetDelete = <ThrowOnError extends boolean = false>(options: Options<CompSetDeleteData, ThrowOnError>): RequestResult<CompSetDeleteResponses, CompSetDeleteErrors, ThrowOnError> => (options.client ?? client).delete<CompSetDeleteResponses, CompSetDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comp_sets/{parentId}',
    ...options
});

/**
 * Get the relationship for a given parent, or an empty one if none exists
 */
export const compSetGet = <ThrowOnError extends boolean = false>(options: Options<CompSetGetData, ThrowOnError>): RequestResult<CompSetGetResponses, CompSetGetErrors, ThrowOnError> => (options.client ?? client).get<CompSetGetResponses, CompSetGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comp_sets/{parentId}',
    ...options
});

/**
 * Save a relationship, augmenting the existing one
 */
export const compSetPatch = <ThrowOnError extends boolean = false>(options: Options<CompSetPatchData, ThrowOnError>): RequestResult<CompSetPatchResponses, CompSetPatchErrors, ThrowOnError> => (options.client ?? client).patch<CompSetPatchResponses, CompSetPatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comp_sets/{parentId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Replace a relationship, deleting existing children not mentioned
 */
export const compSetPut = <ThrowOnError extends boolean = false>(options: Options<CompSetPutData, ThrowOnError>): RequestResult<CompSetPutResponses, CompSetPutErrors, ThrowOnError> => (options.client ?? client).put<CompSetPutResponses, CompSetPutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/comp_sets/{parentId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Query multiple noun rows using the noun-specific request parameters.
 */
export const companyQuery = <ThrowOnError extends boolean = false>(options?: Options<CompanyQueryData, ThrowOnError>): RequestResult<CompanyQueryResponses, CompanyQueryErrors, ThrowOnError> => (options?.client ?? client).get<CompanyQueryResponses, CompanyQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/companies',
    ...options
});

/**
 * Insert a single noun row.
 */
export const companyInsert = <ThrowOnError extends boolean = false>(options: Options<CompanyInsertData, ThrowOnError>): RequestResult<CompanyInsertResponses, CompanyInsertErrors, ThrowOnError> => (options.client ?? client).post<CompanyInsertResponses, CompanyInsertErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/companies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk-save multiple noun rows. Each noun has one or more identifiers in order to 'upsert' an existing document, starting with its id. See the noun's schema documentation.
 */
export const companyActionBulkSave = <ThrowOnError extends boolean = false>(options: Options<CompanyActionBulkSaveData, ThrowOnError>): RequestResult<CompanyActionBulkSaveResponses, CompanyActionBulkSaveErrors, ThrowOnError> => (options.client ?? client).patch<CompanyActionBulkSaveResponses, CompanyActionBulkSaveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/companies/actions/bulk_save',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Save one noun by natural identifer. Each noun has one or more identifiers in order to 'upsert' an existing document. See the noun's schema documentation.
 */
export const companyActionSave = <ThrowOnError extends boolean = false>(options: Options<CompanyActionSaveData, ThrowOnError>): RequestResult<CompanyActionSaveResponses, CompanyActionSaveErrors, ThrowOnError> => (options.client ?? client).patch<CompanyActionSaveResponses, CompanyActionSaveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/companies/actions/save',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Load a single noun by internal id
 */
export const companyGet = <ThrowOnError extends boolean = false>(options: Options<CompanyGetData, ThrowOnError>): RequestResult<CompanyGetResponses, CompanyGetErrors, ThrowOnError> => (options.client ?? client).get<CompanyGetResponses, CompanyGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/companies/{id}',
    ...options
});

/**
 * Update a single noun row.
 */
export const companySave = <ThrowOnError extends boolean = false>(options: Options<CompanySaveData, ThrowOnError>): RequestResult<CompanySaveResponses, CompanySaveErrors, ThrowOnError> => (options.client ?? client).patch<CompanySaveResponses, CompanySaveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/companies/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Load the change log for a single noun by internal id
 */
export const companyGetChangeLog = <ThrowOnError extends boolean = false>(options: Options<CompanyGetChangeLogData, ThrowOnError>): RequestResult<CompanyGetChangeLogResponses, CompanyGetChangeLogErrors, ThrowOnError> => (options.client ?? client).get<CompanyGetChangeLogResponses, CompanyGetChangeLogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/companies/{id}/change_log',
    ...options
});

/**
 * Download a stored content file
 */
export const contentDownload = <ThrowOnError extends boolean = false>(options: Options<ContentDownloadData, ThrowOnError>): RequestResult<ContentDownloadResponses, ContentDownloadErrors, ThrowOnError> => (options.client ?? client).get<ContentDownloadResponses, ContentDownloadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/contents/{id}',
    ...options
});

/**
 * Query multiple noun rows using the noun-specific request parameters.
 */
export const hotelQuery = <ThrowOnError extends boolean = false>(options?: Options<HotelQueryData, ThrowOnError>): RequestResult<HotelQueryResponses, HotelQueryErrors, ThrowOnError> => (options?.client ?? client).get<HotelQueryResponses, HotelQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hotels',
    ...options
});

/**
 * Insert a single noun row.
 */
export const hotelInsert = <ThrowOnError extends boolean = false>(options: Options<HotelInsertData, ThrowOnError>): RequestResult<HotelInsertResponses, HotelInsertErrors, ThrowOnError> => (options.client ?? client).post<HotelInsertResponses, HotelInsertErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hotels',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk-save multiple noun rows. Each noun has one or more identifiers in order to 'upsert' an existing document, starting with its id. See the noun's schema documentation.
 */
export const hotelActionBulkSave = <ThrowOnError extends boolean = false>(options: Options<HotelActionBulkSaveData, ThrowOnError>): RequestResult<HotelActionBulkSaveResponses, HotelActionBulkSaveErrors, ThrowOnError> => (options.client ?? client).patch<HotelActionBulkSaveResponses, HotelActionBulkSaveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hotels/actions/bulk_save',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Save one noun by natural identifer. Each noun has one or more identifiers in order to 'upsert' an existing document. See the noun's schema documentation.
 */
export const hotelActionSave = <ThrowOnError extends boolean = false>(options: Options<HotelActionSaveData, ThrowOnError>): RequestResult<HotelActionSaveResponses, HotelActionSaveErrors, ThrowOnError> => (options.client ?? client).patch<HotelActionSaveResponses, HotelActionSaveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hotels/actions/save',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Return the status of multiple hotels, the results are sorted by id
 */
export const hotelActionStatuses = <ThrowOnError extends boolean = false>(options: Options<HotelActionStatusesData, ThrowOnError>): RequestResult<HotelActionStatusesResponses, HotelActionStatusesErrors, ThrowOnError> => (options.client ?? client).get<HotelActionStatusesResponses, HotelActionStatusesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hotels/actions/statuses',
    ...options
});

/**
 * Download the latest rate chart for a hotel.
 */
export const hotelActionExcelRateChart = <ThrowOnError extends boolean = false>(options: Options<HotelActionExcelRateChartData, ThrowOnError>): RequestResult<HotelActionExcelRateChartResponses, HotelActionExcelRateChartErrors, ThrowOnError> => (options.client ?? client).get<HotelActionExcelRateChartResponses, HotelActionExcelRateChartErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hotels/{hotelId}/actions/excel_rate_chart',
    ...options
});

/**
 * The URI of a gsheet chart for a hotel
 */
export const hotelActionGsheetsRateChart = <ThrowOnError extends boolean = false>(options: Options<HotelActionGsheetsRateChartData, ThrowOnError>): RequestResult<HotelActionGsheetsRateChartResponses, HotelActionGsheetsRateChartErrors, ThrowOnError> => (options.client ?? client).get<HotelActionGsheetsRateChartResponses, HotelActionGsheetsRateChartErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hotels/{hotelId}/actions/gsheets_rate_chart',
    ...options
});

/**
 * Load a single noun by internal id
 */
export const hotelGet = <ThrowOnError extends boolean = false>(options: Options<HotelGetData, ThrowOnError>): RequestResult<HotelGetResponses, HotelGetErrors, ThrowOnError> => (options.client ?? client).get<HotelGetResponses, HotelGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hotels/{id}',
    ...options
});

/**
 * Update a single noun row.
 */
export const hotelSave = <ThrowOnError extends boolean = false>(options: Options<HotelSaveData, ThrowOnError>): RequestResult<HotelSaveResponses, HotelSaveErrors, ThrowOnError> => (options.client ?? client).patch<HotelSaveResponses, HotelSaveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hotels/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Load the change log for a single noun by internal id
 */
export const hotelGetChangeLog = <ThrowOnError extends boolean = false>(options: Options<HotelGetChangeLogData, ThrowOnError>): RequestResult<HotelGetChangeLogResponses, HotelGetChangeLogErrors, ThrowOnError> => (options.client ?? client).get<HotelGetChangeLogResponses, HotelGetChangeLogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hotels/{id}/change_log',
    ...options
});

/**
 * Query multiple noun rows using the noun-specific request parameters.
 */
export const locationQuery = <ThrowOnError extends boolean = false>(options?: Options<LocationQueryData, ThrowOnError>): RequestResult<LocationQueryResponses, LocationQueryErrors, ThrowOnError> => (options?.client ?? client).get<LocationQueryResponses, LocationQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/locations',
    ...options
});

/**
 * Insert a single noun row.
 */
export const locationInsert = <ThrowOnError extends boolean = false>(options: Options<LocationInsertData, ThrowOnError>): RequestResult<LocationInsertResponses, LocationInsertErrors, ThrowOnError> => (options.client ?? client).post<LocationInsertResponses, LocationInsertErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/locations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk-save multiple noun rows. Each noun has one or more identifiers in order to 'upsert' an existing document, starting with its id. See the noun's schema documentation.
 */
export const locationActionBulkSave = <ThrowOnError extends boolean = false>(options: Options<LocationActionBulkSaveData, ThrowOnError>): RequestResult<LocationActionBulkSaveResponses, LocationActionBulkSaveErrors, ThrowOnError> => (options.client ?? client).patch<LocationActionBulkSaveResponses, LocationActionBulkSaveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/locations/actions/bulk_save',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Save one noun by natural identifer. Each noun has one or more identifiers in order to 'upsert' an existing document. See the noun's schema documentation.
 */
export const locationActionSave = <ThrowOnError extends boolean = false>(options: Options<LocationActionSaveData, ThrowOnError>): RequestResult<LocationActionSaveResponses, LocationActionSaveErrors, ThrowOnError> => (options.client ?? client).patch<LocationActionSaveResponses, LocationActionSaveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/locations/actions/save',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Load a single noun by internal id
 */
export const locationGet = <ThrowOnError extends boolean = false>(options: Options<LocationGetData, ThrowOnError>): RequestResult<LocationGetResponses, LocationGetErrors, ThrowOnError> => (options.client ?? client).get<LocationGetResponses, LocationGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/locations/{id}',
    ...options
});

/**
 * Update a single noun row.
 */
export const locationSave = <ThrowOnError extends boolean = false>(options: Options<LocationSaveData, ThrowOnError>): RequestResult<LocationSaveResponses, LocationSaveErrors, ThrowOnError> => (options.client ?? client).patch<LocationSaveResponses, LocationSaveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/locations/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Load the change log for a single noun by internal id
 */
export const locationGetChangeLog = <ThrowOnError extends boolean = false>(options: Options<LocationGetChangeLogData, ThrowOnError>): RequestResult<LocationGetChangeLogResponses, LocationGetChangeLogErrors, ThrowOnError> => (options.client ?? client).get<LocationGetChangeLogResponses, LocationGetChangeLogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/locations/{id}/change_log',
    ...options
});

/**
 * Query multiple relationships.
 */
export const organizationUserQuery = <ThrowOnError extends boolean = false>(options?: Options<OrganizationUserQueryData, ThrowOnError>): RequestResult<OrganizationUserQueryResponses, OrganizationUserQueryErrors, ThrowOnError> => (options?.client ?? client).get<OrganizationUserQueryResponses, OrganizationUserQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization_users',
    ...options
});

/**
 * Get the relationship for a given parent, or an empty one if none exists
 */
export const organizationUserGet = <ThrowOnError extends boolean = false>(options: Options<OrganizationUserGetData, ThrowOnError>): RequestResult<OrganizationUserGetResponses, OrganizationUserGetErrors, ThrowOnError> => (options.client ?? client).get<OrganizationUserGetResponses, OrganizationUserGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization_users/{parentId}',
    ...options
});

/**
 * Save a relationship, augmenting the existing one
 */
export const organizationUserPatch = <ThrowOnError extends boolean = false>(options: Options<OrganizationUserPatchData, ThrowOnError>): RequestResult<OrganizationUserPatchResponses, OrganizationUserPatchErrors, ThrowOnError> => (options.client ?? client).patch<OrganizationUserPatchResponses, OrganizationUserPatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization_users/{parentId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Replace a relationship, deleting existing children not mentioned
 */
export const organizationUserPut = <ThrowOnError extends boolean = false>(options: Options<OrganizationUserPutData, ThrowOnError>): RequestResult<OrganizationUserPutResponses, OrganizationUserPutErrors, ThrowOnError> => (options.client ?? client).put<OrganizationUserPutResponses, OrganizationUserPutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organization_users/{parentId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload a logo file.
 */
export const organizationActionUploadLogo = <ThrowOnError extends boolean = false>(options?: Options<OrganizationActionUploadLogoData, ThrowOnError>): RequestResult<OrganizationActionUploadLogoResponses, OrganizationActionUploadLogoErrors, ThrowOnError> => (options?.client ?? client).post<OrganizationActionUploadLogoResponses, OrganizationActionUploadLogoErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/actions/upload_logo',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * Get the current organization information
 */
export const organizationGet = <ThrowOnError extends boolean = false>(options?: Options<OrganizationGetData, ThrowOnError>): RequestResult<OrganizationGetResponses, OrganizationGetErrors, ThrowOnError> => (options?.client ?? client).get<OrganizationGetResponses, OrganizationGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/my_organization',
    ...options
});

/**
 * Save the current organization information
 */
export const organizationSave = <ThrowOnError extends boolean = false>(options: Options<OrganizationSaveData, ThrowOnError>): RequestResult<OrganizationSaveResponses, OrganizationSaveErrors, ThrowOnError> => (options.client ?? client).patch<OrganizationSaveResponses, OrganizationSaveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/my_organization',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check if the given scopes are allowed for the current session
 */
export const organizationActionAllowedScopes = <ThrowOnError extends boolean = false>(options: Options<OrganizationActionAllowedScopesData, ThrowOnError>): RequestResult<OrganizationActionAllowedScopesResponses, OrganizationActionAllowedScopesErrors, ThrowOnError> => (options.client ?? client).patch<OrganizationActionAllowedScopesResponses, OrganizationActionAllowedScopesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/my_organization/actions/allowed_scopes',
    ...options
});

/**
 * The URI for the organization-specific google drive folder
 */
export const organizationActionGsheetsFolder = <ThrowOnError extends boolean = false>(options?: Options<OrganizationActionGsheetsFolderData, ThrowOnError>): RequestResult<OrganizationActionGsheetsFolderResponses, OrganizationActionGsheetsFolderErrors, ThrowOnError> => (options?.client ?? client).patch<OrganizationActionGsheetsFolderResponses, OrganizationActionGsheetsFolderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/my_organization/actions/gsheets_folder',
    ...options
});

/**
 * Query rate history for the given hotel and date range
 */
export const rateHistoryQueryRates = <ThrowOnError extends boolean = false>(options: Options<RateHistoryQueryRatesData, ThrowOnError>): RequestResult<RateHistoryQueryRatesResponses, RateHistoryQueryRatesErrors, ThrowOnError> => (options.client ?? client).get<RateHistoryQueryRatesResponses, RateHistoryQueryRatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/rate_histories',
    ...options
});

/**
 * Query latest rate rows for the given hotel and date range
 */
export const rateLatestQueryLatest = <ThrowOnError extends boolean = false>(options: Options<RateLatestQueryLatestData, ThrowOnError>): RequestResult<RateLatestQueryLatestResponses, RateLatestQueryLatestErrors, ThrowOnError> => (options.client ?? client).get<RateLatestQueryLatestResponses, RateLatestQueryLatestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/rate_latests',
    ...options
});

/**
 * Query multiple rate rows for the given day range by hotel or city.
 */
export const rateStayQuery = <ThrowOnError extends boolean = false>(options: Options<RateStayQueryData, ThrowOnError>): RequestResult<RateStayQueryResponses, RateStayQueryErrors, ThrowOnError> => (options.client ?? client).get<RateStayQueryResponses, RateStayQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/rate_stays',
    ...options
});

/**
 * Query the invitations.
 */
export const userInvitationQuery = <ThrowOnError extends boolean = false>(options?: Options<UserInvitationQueryData, ThrowOnError>): RequestResult<UserInvitationQueryResponses, UserInvitationQueryErrors, ThrowOnError> => (options?.client ?? client).get<UserInvitationQueryResponses, UserInvitationQueryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/user_invitations',
    ...options
});

/**
 * Insert an invitation.
 */
export const userInvitationInsert = <ThrowOnError extends boolean = false>(options: Options<UserInvitationInsertData, ThrowOnError>): RequestResult<UserInvitationInsertResponses, UserInvitationInsertErrors, ThrowOnError> => (options.client ?? client).post<UserInvitationInsertResponses, UserInvitationInsertErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/user_invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete the invitation by id.
 */
export const userInvitationDelete = <ThrowOnError extends boolean = false>(options: Options<UserInvitationDeleteData, ThrowOnError>): RequestResult<UserInvitationDeleteResponses, UserInvitationDeleteErrors, ThrowOnError> => (options.client ?? client).delete<UserInvitationDeleteResponses, UserInvitationDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/user_invitations/{id}',
    ...options
});

/**
 * Leave the given organization
 */
export const userActionLeaveOrganization = <ThrowOnError extends boolean = false>(options: Options<UserActionLeaveOrganizationData, ThrowOnError>): RequestResult<UserActionLeaveOrganizationResponses, UserActionLeaveOrganizationErrors, ThrowOnError> => (options.client ?? client).patch<UserActionLeaveOrganizationResponses, UserActionLeaveOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/actions/leave_organization',
    ...options
});

/**
 * Get the current user's information
 */
export const userGetCurrentUser = <ThrowOnError extends boolean = false>(options?: Options<UserGetCurrentUserData, ThrowOnError>): RequestResult<UserGetCurrentUserResponses, UserGetCurrentUserErrors, ThrowOnError> => (options?.client ?? client).get<UserGetCurrentUserResponses, UserGetCurrentUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me',
    ...options
});

/**
 * Save the current user's information
 */
export const userSaveCurrentUser = <ThrowOnError extends boolean = false>(options: Options<UserSaveCurrentUserData, ThrowOnError>): RequestResult<UserSaveCurrentUserResponses, UserSaveCurrentUserErrors, ThrowOnError> => (options.client ?? client).patch<UserSaveCurrentUserResponses, UserSaveCurrentUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * My organizations
 */
export const userGetOrganizations = <ThrowOnError extends boolean = false>(options?: Options<UserGetOrganizationsData, ThrowOnError>): RequestResult<UserGetOrganizationsResponses, UserGetOrganizationsErrors, ThrowOnError> => (options?.client ?? client).get<UserGetOrganizationsResponses, UserGetOrganizationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/my_organizations',
    ...options
});
